import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/services/search-service';

export class RoiRegistration {
  public registration: string;
  public releasePrice: number;
  public releaseYear: string;
  public resalePrice: number;
  public resaleYear: string;
  public roi: number;
}

@Component({
  selector: 'pla-new-release-market-data',
  templateUrl: './new-release-market-data.component.html',
  styleUrls: ['./new-release-market-data.component.scss']
})
export class NewReleaseMarketDataComponent implements OnInit {

  @Input() public year: string;
  public paginationPageSize: number = 10;
  private currentPageIndex = 0;
  public paginationChange: EventEmitter<any>;
  public viewResults: RoiRegistration[] = [];
  public displayResults: RoiRegistration[] = [];

  public sorts: { name: string, sort: 'asc' | 'desc' | 'none' }[] = [
    { name: 'registration', sort: 'asc' },
    { name: 'releasePrice', sort: 'none' },
    { name: 'resalePrice', sort: 'none' },
    { name: 'roi', sort: 'none' },
  ]

  constructor(private router: Router, private searchService: SearchService) { }

  ngOnInit(): void {
    this.searchService.getNewReleaseROI(this.year, (results: RoiRegistration[]) => {
      this.viewResults = results;
      this.sortData('registration', 0);
      this.gotoPage(this.currentPageIndex);
    });
  }

  public GotoPlate(registration: string): void {
    this.router.navigate([`/plate-detail/${registration.replace(' ', '')}`])
  }

  public sortChange(sort: string) {
    var index = this.sorts.findIndex(s => s.name == sort);
    if (index == -1) return;
    this.sorts[index].sort = this.sorts[index].sort == 'asc' ? 'desc' : 'asc';
    this.sorts = this.sorts.map(s => { if (s.name == sort) return s; s.sort = 'none'; return s; });
    // sort
    this.sortData(sort, index);
    this.gotoPage(0);
  }

  private sortData(sort: string, index: number): void {
    if (sort === 'registration') {
      if (this.sorts[index].sort === 'asc') {
        this.viewResults = this.viewResults.sort((a, b) => a.registration.localeCompare(b.registration));
      } else {
        this.viewResults = this.viewResults.sort((a, b) => b.registration.localeCompare(a.registration));
      }
    } else {
      if (this.sorts[index].sort === 'asc') {
        this.viewResults = this.viewResults.sort((a, b) => a[sort] - b[sort])
      } else {
        this.viewResults = this.viewResults.sort((a, b) => b[sort] - a[sort])
      }
    }
  }

  public isSorting(sort: string): 'none' | 'asc' | 'desc' {
    var index = this.sorts.findIndex(s => s.name == sort);
    if (index == -1) return 'none';
    return this.sorts[index].sort;
  }

  public sortingIcon(sort: string): string {
    const sortType = this.isSorting(sort);
    if (sortType === 'none') return 'unfold_more';
    if (sortType === 'asc') return 'north';
    if (sortType === 'desc') return 'south';
  }

  public paginate(page: PageEvent): void {
    this.gotoPage(page.pageIndex);
    if (this.paginationChange != null) this.paginationChange.emit(page);
  }

  private gotoPage(pageIndex: number) {
    this.currentPageIndex = pageIndex;
    this.displayResults = this.get_page_range(
      pageIndex,
      this.paginationPageSize
    );
  }

  public get_page_range(page_index, page_size): RoiRegistration[] {
    var min_data_range = page_index * page_size;
    var max_data_range = (page_index + 1) * page_size;
    if (this.viewResults == undefined) return [];
    max_data_range =
      this.viewResults.length > max_data_range
        ? max_data_range
        : this.viewResults.length;
    const visibleResults = this.viewResults.slice(
      min_data_range,
      max_data_range
    );

    return visibleResults;
  }

}
